import BankAccount from "@/entities/bank-account";

export default class BankAccountOption {
  constructor(private bankAccount: BankAccount) {}

  get text(): string {
    return this.value;
  }

  get value(): string {
    return [
      this.bankAccount.bank,
      this.bankAccount.branch,
      this.bankAccount.account_number,
      this.bankAccount.account_type,
      this.bankAccount.account
    ].join(";");
  }
}
